export const TableLoader = ()=>{
    return(<>
        <div style={{
            height: "4px",
            width: "100%",
            backgroundColor: "#f3f3f3",
            overflow: "hidden",
            position: "relative"
        }}>
            <div style={{
                height: "100%",
                width: "100%",
                background: "linear-gradient(to right, #f97316 0%, #f97316 50%, transparent 100%)",
                animation: "loader-slide 1s infinite"
            }}></div>
        </div>
        <style>{`
                @keyframes loader-slide {
                    0% { transform: translateX(-100%); }
                    100% { transform: translateX(100%); }
                }
            `}</style>
    </>)

}
